import { Modal, Button, Alert } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { Gallery } from '../../components/Gallery'
import { GalleryAdd } from './GalleryAdd';
import { DeleteModal } from '../../components/Modal/DeleteModal';
import { shallowEqual, useDispatch, useSelector, useStore } from 'react-redux';
import * as actions from './_redux/IconsActions'
import { AppBar, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, TextField } from '@material-ui/core';
import * as GalleryUIHelper from './GalleryUIHelper'
import _ from 'lodash';
import { fetchGallery, gotoPage, changeType, searchFor } from './_redux/IconsSlice';
import { PaginationLinks } from '../../../_metronic/_partials/controls';
import SearchCustomInput from '../../components/Input/SearchCustomInput';
import { Loading } from '../../components/Loading/Loading'

export function IconsGallery ({
    canUpload = false,
    canEdit = false,
    canDelete = false,
    onSelect = null,
    onUnSelect = null,
    onClick = null
}) {

    const [ showMessage, setShowMessage ] = useState(null)
    const [ showDeleteModal, setShowDeleteModal ] = useState(false)
    const [ showEditModal, setShowEditModal ] = useState(false)
    const [ selectedIcon, setSelectedIcon ] = useState(null)

    // Getting curret state of products list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.icons }),
        shallowEqual
    );
    const { totalCount, entities, querySelector } = currentState;
    
    // Products Redux state
    const dispatch = useDispatch();

    // useEffect
    useEffect(() => {
        dispatch(fetchGallery())
            .then(() => null)
            .catch(() => null)
    }, [ dispatch, querySelector ])

    // console.log(currentState);
    
    // Fetch Data
    const fetchData = () => {
        dispatch(fetchGallery())
            .then(() => null)
            .catch(() => null)
    }

    /**
     *
     */
    const handleCloseEditModal = () => {
        setShowEditModal(false)
        setSelectedIcon(null)
    }

    /**
     *
     */
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false)
        setSelectedIcon(null)
    }

    /**
     * 
     */
    const handleDeleteModal = () => {
        dispatch(actions.deleteIcon(selectedIcon.id))
            .then(() => {
                fetchData()
                handleCloseDeleteModal()
            }).catch(() => {
                setShowMessage({ type: 'danger', message: 'Erro ao apagar icone' })
                handleCloseDeleteModal()
            })
    }

    /**
     * 
     */
    const handleEditModal = () => {
        dispatch(actions.update(selectedIcon))
            .then(() => {
                fetchData()
                handleCloseEditModal()
            }).catch(() => {
                setShowMessage({ type: 'danger', message: 'Erro ao apagar icone' })
                handleCloseDeleteModal()
            })
    }

    /**
     * 
     * @param {*} event 
     * @param {*} newValue 
     */
    function handleChangeType(event, newValue) {
        dispatch(changeType(newValue));
    }

    /**
     *
     * @param {*} event
     * @param {*} data
     */
    const onDelete = ( event, data ) => {
        setShowDeleteModal(true)
        setSelectedIcon(data)
    }

    /**
     *
     * @param {*} event
     * @param {*} data
     */
    const onEdit = (event, data ) => {
        setShowEditModal(true)
        setSelectedIcon(data)
    }

    const handleOnSearch = (event, value) => {
        dispatch(searchFor(value));
    }

    //
    const paginationProps = {
        totalSize: totalCount,
        sizePerPage: querySelector.itemsPerRow,
        page: querySelector.page,
        paginationSize: 4,
        onPageChange: page => {
            dispatch(gotoPage(page));
        }
    }

    return (
        <>
        <div style={{position: 'relative'}}>
        { currentState.loading === 'carregando' ?
        <Loading/>:null
        }
            {showMessage && <Alert variant={showMessage.variant}>{showMessage.message}</Alert>}
            { canUpload && <GalleryAdd onReload={fetchData} />}
            
            <AppBar position="static" color="transparent">
                <Tabs
                value={querySelector.type}
                onChange={handleChangeType}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="secondary"
                textColor="secondary"
                >
                    { GalleryUIHelper.IMAGE_TYPE.map((value, index) => <Tab key={index} label={value.name} value={value.id} /> ) }
                </Tabs>
            </AppBar>

            <div className="row mt-4">
                <div className="col-12 col-md-6 d-flex justify-content-start"></div>
                <div className="col-12 col-md-6 d-flex justify-content-end">
                    <SearchCustomInput 
                        value={querySelector.search}
                        onClick={handleOnSearch} />
                </div>
            </div>

            <div className="mb-16 mt-4">
                <Gallery tileData={entities ?? []}
                    onDelete={ canDelete ? onDelete : null }
                    onEdit={ canEdit ? onEdit : null }
                    onSelect={onSelect}
                    onClick={onClick}
                    onUnSelect={onUnSelect}
                />
                {/* <TablePagination /> */}
                <PaginationLinks paginationProps={paginationProps} />
            </div>
            {/* Begin Edit Modal */}
            { canEdit && <Modal show={showEditModal} onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex justify-content-between">
                    <FormControl>
                    {selectedIcon &&
                        <TextField
                            id="standard-name"
                            label="Nome"
                            defaultValue={selectedIcon.name}
                            onChange={(event) => {
                                console.log(selectedIcon)
                                setSelectedIcon({
                                    ...selectedIcon,
                                    name: event.target.value,
                                })
                            }}
                        />
                    }
                    </FormControl>
                    {selectedIcon && <FormControl>
                        <InputLabel htmlFor="type-simple">Tipo</InputLabel>
                        <Select
                        value={selectedIcon.type}
                        onChange={(event) => {
                            console.log(selectedIcon)
                            setSelectedIcon({
                                ...selectedIcon,
                                type: event.target.value,
                            })
                        }}
                        inputProps={{
                            name: 'type-simple',
                            id: 'type-simple',
                        }}
                        >
                            { GalleryUIHelper.IMAGE_TYPE.map((el) => <MenuItem value={el.id}>{el.name}</MenuItem>) }
                        </Select>
                    </FormControl>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>Close</Button>
                    <Button variant="primary" onClick={handleEditModal}>Salvar</Button>
                </Modal.Footer>
            </Modal> }
            {/* End Edit Modal */}
            {/* Begin Delete Modal */}
            { canDelete && <DeleteModal
                show={showDeleteModal}
                onClose={handleCloseDeleteModal}
                onAccept={handleDeleteModal}
                />}
            {/* End Delete Modal */}
            </div>
        </>
    )
}
